export const SET_PURCHASES_VERIFY = 'setPurchasesVerify'
export const SET_BEST_SELLING = 'setBestSelling'
export const SET_TOP_BUYERS = 'setTopBuyers'
export const SET_TOP_STORES = 'setTopStores'
export const SET_TOTAL_PAYMENT = 'setTotalPayment'
export const SET_WEEK_SALES = 'setWeekSales'